import { NavLink } from 'react-router';
import { navItems } from './navItems';
import { useLogout } from '../hooks/useLogout';

export const Sidebar = () => {
  const logout = useLogout();

  return (
    <aside className="hidden md:flex w-56 shrink-0 bg-white border-r border-gray-200 flex-col">
      <div className="h-14 flex items-center px-4 border-b border-gray-200">
        <span className="font-semibold text-gray-900">Operations</span>
      </div>
      <nav className="flex flex-col gap-1 p-2 flex-1">
        {navItems.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-2 border-t border-gray-200">
        <button
          onClick={logout}
          className="w-full px-3 py-2 rounded-lg text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900 transition-colors text-left"
        >
          Logout
        </button>
      </div>
    </aside>
  );
};
